export default __webpack_public_path__ + "static/media/47.9eb9fb8b.png";